// Exports
export default {
	"content": "content_Um3l+",
	"titleAndDescription": "titleAndDescription_nPe0A",
	"qr": "qr_KjWBs"
};
